import styles from './mui.module.scss';


export const Typography = {
    fontFamily: styles.fontFamily
}
    
